import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;
